import React from "react";

// Cornice "browser" riutilizzabile: barra con 3 pallini + screenshot del prodotto.
// `src` punta agli screenshot in /landing-assets/screenshots/ (sostituibili senza
// toccare il codice).
export default function BrowserFrame({ src, alt = "", className = "" }) {
  return (
    <div className={`browser-frame ${className}`.trim()}>
      <div className="browser-bar" aria-hidden="true">
        <span className="browser-dot" />
        <span className="browser-dot" />
        <span className="browser-dot" />
      </div>
      <div className="browser-screen">
        <img src={src} alt={alt} loading="lazy" />
      </div>
    </div>
  );
}
